module.exports = __webpack_public_path__ + "img/trending-image-post-2.e583fe43.jpg";